import React from 'react';
import { Card, CardBody } from 'reactstrap';
import DefaultRateImage from '../../../assets/images/FAQ_default_and_recovery_image.png';
import { useDict } from '../../../contexts/LanguageContext';
import useWindowSize from '../../../hooks/useWindowSize';
import ROUTE_NAME from '../../../routes/RouteName';
import { BootstrapBreakpoints } from '../../../utils/constants';
import FaqContainer from './FaqContainer';

const DefaultAndRecovery = () => {
    const dict = useDict();

    const { width } = useWindowSize();
    const isMobile = width <= BootstrapBreakpoints.SM;

    return (
        <FaqContainer
            navigationActive="defaultandrecovery"
            prevLink={ROUTE_NAME.FAQ_FEES_AND_CHARGES}
            prevTitle={dict.feesAndCharges}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.defaultAndRecovery}
                        </h3>
                    </div>
                    <p>
                        <strong>
                            {dict.defaultAndRecoveryTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle1Text1}
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle1Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.defaultAndRecoveryTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle2Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.defaultAndRecoveryTitle3}
                        </strong>
                    </p>
                    <div className='w-100 flex-justify-content-center mb-3'>
                        <img
                            src={DefaultRateImage}
                            alt="defaultRateImage"
                            style={{
                                width: isMobile ? '100%' : '60%',
                                objectFit: 'contain',
                                minHeight: isMobile ? '20vh' : undefined,
                            }}
                        />
                    </div>
                    <p>
                        {dict.defaultAndRecoveryTitle3Text1}
                    </p>
                    <ul>
                        <li>{dict.defaultAndRecoveryTitle3Text1List1}</li>
                        <li>{dict.defaultAndRecoveryTitle3Text1List2}</li>
                        <li>{dict.defaultAndRecoveryTitle3Text1List3}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.defaultAndRecoveryTitle4}
                        </strong>
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle4Text1}
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle4Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.defaultAndRecoveryTitle5}
                        </strong>
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle5Text1}
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle5Text2}
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle5Text3}
                    </p>
                    <ul>
                        <li>{dict.defaultAndRecoveryTitle5Text3List1}</li>
                        <li>{dict.defaultAndRecoveryTitle5Text3List2}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.defaultAndRecoveryTitle6}
                        </strong>
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle6Text1}
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle6Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.defaultAndRecoveryTitle7}
                        </strong>
                    </p>
                    <p>
                        {dict.defaultAndRecoveryTitle7Text1}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default DefaultAndRecovery;
